import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { keyframes } from '@mui/system';

const gradientShift = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const MissionStatement = () => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    return (
        <Box
            sx={{
                textAlign: 'center',
                py: { xs: 6, md: 10 },
                px: 2,
            }}
        >
            <Typography
                sx={{
                    fontWeight: 800,
                    fontSize: { xs: '1.75rem', sm: '2.25rem', md: '3rem' },
                    letterSpacing: '-0.5px',
                    background: isDark
                        ? 'linear-gradient(270deg, #007FFF, #66B2FF, #99CCFF, #007FFF)'
                        : 'linear-gradient(270deg, #007FFF, #66B2FF, #99CCFF, #007FFF)',
                    backgroundSize: '300% 300%',
                    animation: `${gradientShift} 6s ease infinite`,
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                }}
            >
                Better data. Smarter decisions. Every single day.
            </Typography>
        </Box>
    );
};

export default MissionStatement;